import { Link } from "react-router-dom";
import { motion } from "framer-motion";


const ProductGrid = ({ products }) => {

  return (

    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">

      {products.map((product, index) => (

        <motion.div

          key={product._id}

          initial={{ opacity: 0, y: 40 }}

          whileInView={{ opacity: 1, y: 0 }}

          transition={{
            duration: 0.5,
            delay: index * 0.08,
          }}

          viewport={{ once: true }}

          className="
            bg-white
            rounded-2xl
            overflow-hidden
            border
            border-gray-200
            hover:shadow-xl
            hover:-translate-y-2
            transition-all
            duration-300
          "

        >


          {/* Image */}

          <div className="h-64 bg-gray-100 overflow-hidden">

            <img

              src={product.image?.asset?.url}

              alt={product.name}

              className="
                w-full
                h-full
                object-contain
                hover:scale-105
                transition-transform
                duration-500
              "

            />

          </div>



          {/* Details */}

          <div className="p-6">


            <span className="
              inline-block
              bg-green-100
              text-green-700
              px-3
              py-1
              rounded-full
              text-sm
            ">

              {product.category?.title}

            </span>



            <h3 className="
              mt-4
              text-lg
              font-semibold
              text-gray-900
            ">

              {product.name}

            </h3>



            <p className="
              mt-3
              text-xl
              font-bold
              text-green-600
            ">

              TZS {Number(product.price).toLocaleString()}

            </p>



            <Link

              to={`/product/${product._id}`}

              className="
                block
                mt-6
                text-center
                border
                border-green-600
                text-green-600
                rounded-xl
                py-3
                font-medium
                hover:bg-green-600
                hover:text-white
                transition
              "

            >

              View Product

            </Link>


          </div>


        </motion.div>

      ))}


    </div>

  );

};


export default ProductGrid;